import moment from "moment";
import momentTimezone from "moment-timezone";

/**
 * Persist roster times as UTC wall-clock ISO, matching RESOURCE_WORK_HOURS
 * written by the weekly backend job (09:00 → 2026-08-14T09:00:00Z).
 */
export function standardizeRosterTime(time) {
  if (time == null || time === "") return time;

  if (time instanceof Date) {
    return moment.utc(time).seconds(0).milliseconds(0).format();
  }

  const value = String(time);
  if (value.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(value)) {
    return moment.utc(value).seconds(0).milliseconds(0).format();
  }

  return momentTimezone(value)
    .utc(true)
    .seconds(0)
    .milliseconds(0)
    .format();
}

export function calendarRouteDefaults(params, fallbackDate) {
  const view = params && params.view ? params.view : "dayGridMonth";
  const date = params && params.date ? params.date : fallbackDate;
  return { view, date };
}
